import Header from "@/components/Header";
import Sidebar from "@/components/Sidebar";
import route from "@/constants/route";
import { hasPermission } from "@/rbac";
import { RootState } from "@/store";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

const Layout = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false)
    const location = useLocation()
    const navigate = useNavigate()
    const {auth} = useSelector((state: RootState) => state.auth)

    useEffect(() => {
        !hasPermission(auth, location.pathname) && navigate(route.ERROR403)
    }, [location.pathname])

    useEffect(() => {
        _.isEmpty(auth.name) && navigate(route.LOGIN)
    }, [auth])

    useEffect(() => {
        if(window.innerWidth >= 1024) {
            setSidebarOpen(true)
        }
    }, [])

    return (
        <>
            {/* Navigation */}
            <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

            {/* <!-- ===== Content Area Start ===== --> */}
            <div className="relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden">
                {/* <!-- ===== Header Start ===== --> */}
                <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                {/* <!-- ===== Header End ===== --> */}

                {/* <!-- ===== Main Content Start ===== --> */}
                <main>
                    <div className="mx-auto p-4 md:p-6 2xl:p-10">
                        <Outlet />
                    </div>
                </main>
                {/* <!-- ===== Main Content End ===== --> */}
            </div>
        </>
    );
};

export default Layout;
